import { HeroSection, Section, SectionSubtitle, SectionTitle } from '@web_opxp/components';
import { ETagType, renderStringToReact, useTranslation } from '@web_opxp/features';
import Env from '../../base/env';
import { AssessmentProgress, ProgressPageState } from '../AssessmentProgress';

export default function CFQEvaluationSubpage() {
  const { t } = useTranslation();

  const imageSrc = `${Env.AssetsBaseUrl}/feature/cfq/cfq_end.svg`;
  return (
    <div className="cfq-subpage">
      <HeroSection imgSrc={imageSrc}>
        <SectionTitle>{t('CFQ.EvaluationRunning.Title')}</SectionTitle>
        <SectionSubtitle wrapperTag="div">
          {renderStringToReact(t('CFQ.EvaluationRunning.Description'), ETagType.div)}
        </SectionSubtitle>
      </HeroSection>
      <Section>
        <AssessmentProgress page={ProgressPageState.CFQSessionDone} cfq={true} />
      </Section>
    </div>
  );
}
